module.exports = __webpack_public_path__ + "media/newstyle/images/stars_1-0bf021333754c03f79f0d6c43ccaff24.svg";